module.exports = __webpack_public_path__ + "static/media/ло.c5e0cbba.mp3";